<div class="confirm d-flex align-items-center justify-content-center"
  style="background-color: white !important;" *ngIf="!isBuyNow && !isLegacyCreditApp">
  <div class="confirm-body row m-0">
    <div class="col-12 px-0">
      <div id="confirm_image_id" class="confirm-image">
        <span class="dt-icon dt-icon-finish"></span>
      </div>
      <div class="confirm-title" id="confirm_title">{{thankyouInfo?.ThankyouTitle}}</div>
      <div class="confirm-subtitle" id="confirm_subtitle">{{thankyouInfo?.ThankyouMessage}}</div>
    </div>
    <div class="col-12 d-flex cta-col cta-section m-0"  *ngIf="isBuyNow || isLegacyCreditApp">
      <div class="w-100 ml-auto d-flex cta-alignment">
        <button id="back_cta" type="button" class="secondary-cta mr-auto" (click)="goPrev()">
          {{ thankyouInfo?.BackCta}}
        </button>
        <button id="back_cta" type="button" class="primary-cta ml-auto" (click)="goNext()">
          {{ thankyouInfo?.NextCta}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="row {{isLegacyCreditApp? '' : 'm-0'}} buyNowConfirmation" [ngClass]="{ 'mobMargin': isLegacyCreditApp}" *ngIf="isBuyNow || isLegacyCreditApp">
  <div class="col-12 pdr-content">
          <div class="pqr-body">
              <div class="{{isLegacyCreditApp? '' : 'row'}} h-100" [ngClass]="{ 'CAPadding': isLegacyCreditApp}">
              <div class="pqr-left col col-xl-6 col-lg-6 col-sm-12" *ngIf="!isLegacyCreditApp">
                  <img *ngIf="this.vehicleInfo?.VehicleImage" src="{{ this.vehicleInfo?.VehicleImage }}" alt="{{ this.vehicleInfo?.MakeModelName }}" class="img-fluid" />
                  <h4 *ngIf="this.vehicleInfo?.MakeModelName" class="text-secondary-dark">{{ this.vehicleInfo?.MakeModelName }}</h4>
                  <h5 *ngIf="this.vehicleInfo?.StyleName" class="text-secondary-dark">{{ this.vehicleInfo?.StyleName }}</h5>
              </div>
              <div class="pqr-right col {{isLegacyCreditApp ? 'col-xl-12 col-lg-12' : 'col-xl-6 col-lg-6'}} col-sm-12 col-12 d-flex align-items-center justify-content-center" [ngClass]="{ 'flexDirect': isLegacyCreditApp}">
                <div class="pqr-header">
                  <div class="dt-icon dt-icon-certified-approved"></div>
                  <div class="title title-text an-h-line-height">{{ this.thankyouInfo?.BuyNowTitle}}</div>
                  <div class="subHeader text-dark-gray an-p-line-height">{{this.thankyouInfo?.BuyNowSubTitle}}</div>
                </div>

                <div class="value-my-trade" *ngIf="isLegacyCreditApp">
                  <div class="clearfix">
                        <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div class="col-xs-12 col-sm-12 col-md-12 paddingRight">
                                <h3>
                                    <a id="valueMyCarShop" class="widget-link an-h-line-height" (click)="goToSMC()" title="Value My Trade">Value My Trade</a>
                                </h3>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-lg-12 padding-0 col-md-12 padTop">
                            <div class="col-xs-12 col-lg-12 col-md-12">
                                <p class=" an-p-line-height">
                                    Have our appraisal experts provide you a free certified offer, good at any store.
                                </p>
                            </div>
                        </div>
                </div>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="col-12 d-flex cta-col cta-section m-0"  *ngIf="isBuyNow && !isLegacyCreditApp">
  <div class="w-100 ml-auto d-flex cta-alignment">
    <button id="back_cta" type="button" class="secondary-cta mr-auto" (click)="goPrev()" [disabled]="ctaDeactivate">
      {{ thankyouInfo?.NewApplication}}
    </button>
    <button id="back_cta" type="button" class="primary-cta ml-auto" (click)="goNext()" [disabled]="ctaDeactivate">
      {{ thankyouInfo?.Next}}
    </button>
  </div>
</div>
</div>
